import React from 'react'
import { Button, Typography, useMediaQuery, useTheme } from '@mui/material'
import { PlusIcon } from '../../../../components/Icons'
import { useNavigate } from 'react-router-dom'

import { useSidebarContext } from '../../../../contexts/Old_SidebarContext'
// import baseUrl from '../../../../config/baseUrl'

const NewChatButton = () => {
  const {
    setShowFileUploadBox,
    setOpenSpeechToText,
    isLoading,
    isFileUploading,
    setInputMessage,
    setSelectedTab,
    setAllHistory,
    setThreadId,
    setSidebar,
    setNewChatClicked,
    setUploadedFileName,
    setIsRefFileUploaded,
    setGlobalThreadId,
    uniqueString,
    setUniqueString,
    deleteUniqueString,
  } = useSidebarContext()

  const navigate = useNavigate()
  // const token = sessionStorage.getItem('token')
  // const userId = sessionStorage.getItem('userId')
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  // const createChat = (randomObject: any) => {
  //   return fetch(`${baseUrl}/api/users/StoreHistory1`, {
  //     method: 'POST',
  //     mode: 'cors',
  //     headers: {
  //       'Content-Type': 'application/json',
  //     },
  //     body: JSON.stringify({
  //       SearchTitle: randomObject.searchTitle,
  //       searchResult: randomObject.searchResult,
  //       UserId: userId,
  //       ThreadId: threadId,
  //       Token: globalTokenConsumed,
  //     }),
  //   })
  // }

  // const generateRandomString = (length: any) => {
  //   const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  //   let result = ''
  //   for (let i = 0; i < length; i++) {
  //     const randomIndex = Math.floor(Math.random() * characters.length)
  //     result += characters.charAt(randomIndex)
  //   }
  //   return result
  // }
  // const generateRandomObject = () => {
  //   const randomSearchTitle = generateRandomString(10)
  //   const randomSearchResult = generateRandomString(20)

  //   const randomObject = {
  //     searchTitle: randomSearchTitle,
  //     searchResult: randomSearchResult,
  //   }

  //   return randomObject
  // }
  const newChat = async () => {
    // Close file upload and speech to text dialogs
    setShowFileUploadBox(false)
    setOpenSpeechToText(false)

    // Reset all file upload state
    setIsRefFileUploaded(false)
    setUploadedFileName([])

    // Delete unique string from server if it exists
    if (uniqueString) {
      try {
        await deleteUniqueString(uniqueString)
        setUniqueString('')
      } catch (error) {
        console.error('Error cleaning up file upload session:', error)
      }
    }

    // Clear sessionStorage file upload data
    sessionStorage.removeItem('uploadedFiles')
    sessionStorage.removeItem('uploadedTotalSize')
    sessionStorage.removeItem('uploadUniqueString')
    sessionStorage.removeItem('selectedFileMeta')
    sessionStorage.removeItem('uploadedFileMeta')

    // Reset chat state
    setInputMessage('')
    setNewChatClicked(true)
    setSelectedTab(1)
    setAllHistory([])
    setThreadId(null)
    setGlobalThreadId(null)

    // Close sidebar on mobile
    if (isMobile) {
      setSidebar(false)
    }

    navigate('/NewChat')
  }
  return (
    <Button
      onClick={newChat}
      variant='contained'
      disabled={isLoading || isFileUploading}
      startIcon={<PlusIcon />}
    >
      <Typography variant='body2'>New Chat</Typography>
    </Button>
  )
}

export default NewChatButton
